var map = {
	"./roll1.png": "f071",
	"./roll10.png": "542b",
	"./roll11.png": "a55a",
	"./roll12.png": "3c2d",
	"./roll2.png": "d413",
	"./roll3.png": "9ea4",
	"./roll4.png": "da98",
	"./roll5.png": "86a6",
	"./roll6.png": "125c",
	"./roll7.png": "9b9e",
	"./roll8.png": "2f55",
	"./roll9.png": "42c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2fc";